import styles from './index.less';
import animate from '../../styles/animate.less';
import {addClass,removeClass,hideNode} from '../../utils/utils';
export default class OpenTip {
  constructor(props) {
    this.wrapper = props.wrapper;
    this.url = props.url;
    this.duration = props.duration;
    this.visible = true;
    if (!this.url || !this.duration) return;
    this._init();
  }

  _init() {
    this._render();
    this._autoHide();
  }

  _render() {
    this.dom = document.createElement('div');
    addClass( this.dom,styles['opentip-wrapper'])
    this.dom.innerHTML = `<div class="animediv ${animate['animate__animated']}">
                            <img class="${styles['open-tip-img']}" src="${this.url}"/>
                          </div>`;
    this.dom.addEventListener('click', ev => {
      ev.stopPropagation();
      this.hide();
    });
    this.wrapper.addEventListener('click', this.hide.bind(this), false);
    this.wrapper.appendChild(this.dom);
  }

  _autoHide() {
    if (this.duration) {
      setTimeout(() => {
        if (this.visible) {
          this.hide();
        }
      }, Number(this.duration) * 1000);
    }
  }

  show() {
    const animediv = this.dom.querySelector('.animediv');
    this.dom.style.display = 'block';
    removeClass(animediv,animate['animate__bounceOut'])
    this.visible = true;
  }

  hide() {
    const animediv = this.dom.querySelector('.animediv');
    addClass(animediv,animate['animate__bounceOut']);
    hideNode(this.dom);
    this.visible = false;
  }
}
